import type { CSSObjectWithLabel } from 'react-select';
import React from 'react';
import { ClearIndicatorProps, ControlProps, OptionProps, StylesConfig } from 'react-select';
import { Color } from '@diritto/common/style/color';
import { FontWeight, TypographySize } from '@diritto/common/style/typography';
import { ClearIcon } from 'icons/ClearIcon';

export type OptionType = { label: string; value: string }; // 이 타입은 실제 옵션의 타입에 맞게 수정해야 합니다.

export const CustomClearIndicator = <T extends { label: string; value: string }>({
  innerProps,
  clearValue,
}: ClearIndicatorProps<T>) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
  <div
    {...innerProps}
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    }}
    onClick={clearValue}>
    <ClearIcon color={Color.Gray500} size={20} />
  </div>
);

export const CustomComponents = { ClearIndicator: CustomClearIndicator };

export const SelectStyle: StylesConfig<OptionType, false> = {
  indicatorSeparator: (): CSSObjectWithLabel => ({
    display: 'none',
  }),
  container: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    width: '100%',
  }),
  control: (provided: CSSObjectWithLabel, state: ControlProps<OptionType, false>): CSSObjectWithLabel => ({
    ...provided,
    height: '100%',
    border: state.isFocused ? `1px solid ${Color.Primary500}` : `1px solid ${Color.Gray300}`,
    boxShadow: 'none',

    ':hover': {
      border: state.isFocused ? `1px solid ${Color.Primary500}` : `1px solid ${Color.Gray300}`,
      borderShadow: 'none',
    },
  }),
  clearIndicator: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    color: Color.Gray500,
    ':hover': {
      color: Color.Gray500,
    },
  }),
  dropdownIndicator: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    color: Color.Gray400,
    ':hover': {
      color: Color.Gray400,
    },
  }),
  placeholder: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    color: Color.Gray500,
    fontSize: TypographySize.XXSmall.fontSize,
    fontWeight: FontWeight.Medium,
  }),
  singleValue: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    fontSize: TypographySize.XXSmall.fontSize,
    fontWeight: FontWeight.Medium,
  }),
  valueContainer: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    fontSize: TypographySize.XXSmall.fontSize,
    fontWeight: FontWeight.Medium,
  }),
  menu: (provided: CSSObjectWithLabel): CSSObjectWithLabel => ({
    ...provided,
    fontSize: TypographySize.XXSmall.fontSize,
    fontWeight: FontWeight.Medium,
    backgroundColor: Color.White,
    padding: '8px',
  }),
  option: (provided: CSSObjectWithLabel, state: OptionProps<OptionType, false>): CSSObjectWithLabel => ({
    ...provided,
    fontSize: TypographySize.XXSmall.fontSize,
    fontWeight: FontWeight.Medium,
    color: Color.Black,
    backgroundColor: state.isSelected || state.isFocused ? Color.Gray100 : provided.backgroundColor,

    borderRadius: '4px',
    overflow: 'hidden',
    ':active': {
      ...provided[':active'],
      backgroundColor: Color.Gray300,
    },
  }),
};
